export default "__VITE_ASSET__BbpHSLxv__"